mutation UpsertCharityBankAccountChecklistItem(
  $input: UpsertCharityBankAccountChecklistItemInput!
) {
  upsertCharityBankAccountChecklistItem(input: $input) {
    checklistItem {
      id
      itemKey
      status
      notes
      reviewedAt
    }
  }
}
